import { render } from "./orders.vue?vue&type=template&id=210cd800"
import script from "./orders.vue?vue&type=script&lang=js"
export * from "./orders.vue?vue&type=script&lang=js"

import "./orders.vue?vue&type=style&index=0&id=210cd800&lang=css"
import "./orders.vue?vue&type=style&index=1&id=210cd800&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__